import signupModule from './signupModule'

const modules = {
  signupModule,
}

export default {
  modules,
}
